export default {
  postDetail_reply_time: 'By reply time',
  postDetail_comment_time: 'By comment time',
  postDetail_undercarriage_tip1: 'You can find the content in "My posts - I managed comments and replies" after removing it, and it can be restored to shelves. Remove?' ,
  postDetail_cancel_reply: 'Cancel quality reply',
  postDetail_set_reply: 'Set as quality reply',
  postDetail_enter_commments: 'Please enter your comment',
  postDetail_limit_comment: 'Upper limit for comment words is 1000',
  postDetail_related_resources: 'Related resources',
  postDetail_had_click: 'You are a member of @',
  postDetail_undercarriage_tip2: 'You can find the content in "My posts - I managed posts" after removing it, and it can be restored to shelves. Remove?'
}
